"use strict";
exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isArray.js
// module id = 560
// module chunks = 0